import React from "react";
import { Link } from "react-router-dom";
import icon from "../assets/iconWhite.svg";

export default function Header() {
	return (
		<header className="fixed top-0 left-0 w-full bg-[#0a1633] text-[#cbbca3] shadow-md z-50">
			<nav className="flex justify-center items-center gap-10 py-5">
				<ul className="flex items-center gap-8 font-semibold text-sm uppercase">
					<li>
						<Link
							to="/about"
							className="hover:text-white hover:underline underline-offset-8 transition-colors duration-300"
						>
							Acerca de
						</Link>
					</li>
					<li>
						<Link
							to="/rental"
							className="hover:text-white hover:underline underline-offset-8 transition-colors duration-300"
						>
							Alquiler
						</Link>
					</li>
					<li>
						<Link
							to="/services"
							className="hover:text-white hover:underline underline-offset-8 transition-colors duration-300"
						>
							Servicios
						</Link>
					</li>
				</ul>

				<div className="flex items-center justify-center mx-10">
					<Link to="/">
						<img
							src={icon}
							alt="logo"
							className="h-10 w-auto object-contain drop-shadow-md"
						/>
					</Link>
				</div>

				<ul className="flex items-center gap-10 font-semibold text-sm uppercase">
					<li>
						<Link
							to="/contact"
							className="hover:text-white hover:underline underline-offset-8 transition-colors duration-300"
						>
							Contacto
						</Link>
					</li>
					<li>
						<Link
							to="/manual"
							className="hover:text-white hover:underline underline-offset-8 transition-colors duration-300"
						>
							Manual de procedimiento
						</Link>
					</li>
				</ul>
			</nav>
		</header>
	);
}
